import { classes, icons, Link } from '@portal/components'
import paths from 'paths'

const { ArrowUpRight } = icons

export const docsAreas = {
  authentication: 'auth-and-authorization/cloud-authentication',
  authWebhook: 'auth-and-authorization/cloud-authentication#iVraY',
  authSharedKey: 'auth-and-authorization/shared-key',
  apiKey: 'big-peer/http-api/authorization#6F482',
  changelog: 'changelog',
  httpApi: 'big-peer/http-api/authorization',
  querySyntax: 'legacy/query-syntax',
  kakfaConsumer: 'big-peer/bigpeer/cdc#ZiMzT',
  smallPeerInfo:
    'big-peer/bigpeer/data-browser-and-editor/capturing-small-peer-info',
  legacySyntax: 'dql/UAopX0p28gyjw3guV1APQ',
  dql: 'dql/dql',
  deviceMetadata: 'cloud/portal/capturing-small-peer-info#8GC6p',
  mongoConnector: 'cloud/mongodb-connector',
}
export type DocsArea = keyof typeof docsAreas

type Props = {
  /**
   * An optional text to display in the link. Defaults to 'Read the docs'.
   */
  text?: string
  /**
   * An optional area of the docs to go to. If not provided, the link will go to
   * the root of the docs: https://docs.ditto.live.
   */
  docsArea?: DocsArea
  /**
   * An optional variant to use for the link. Defaults to 'accent'  (_not_ monochrome, which is primary)
   */
  variant?: 'accent' | 'primary'
  /**
   * A boolean to add an underline to the link
   */
  underline?: boolean
  /**
   * A boolean to show the external link icon. Defaults to true.
   */
  showIcon?: boolean
}
export default function ReadTheDocsLink({
  text = 'Read the docs',
  docsArea,
  variant = 'accent',
  underline,
  showIcon = true,
}: Props) {
  return (
    <Link
      href={paths.dittoDocs(docsArea)}
      isBlank
      className={classes(
        'inline-flex items-center',
        variant === 'accent'
          ? 'text-foreground-accent'
          : 'text-foreground-normal',
        {
          'underline underline-offset-2': underline,
        },
      )}
    >
      {text}
      {showIcon && <ArrowUpRight className="ml-1" />}
    </Link>
  )
}
